export var formFieldTooltipDefaultTheme = {
  Root: {
    base: {}
  },
  Indicator: {
    base: {
      top: -2,
      right: -2
    }
  }
};